<template>
  <div class="datagrid-item">
    <div class="datagrid-title">Статус</div>
    <div class="datagrid-content mt-1"><b>{{ getVal() }}</b></div>
  </div>
</template>

<script>
import {defineComponent} from "vue"
import optionValues from "@/modules/promopushka/services/values"

export default defineComponent({
  name: "Status",
  props: {
    data: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    function getVal() {
      let status = props.data?.status

      if (status === undefined) {
        throw new Error("Не указан status")
      }

      if (status === null) {
        return "Не выбран"
      }

      let item = detect(status)

      if (item === null) {
        return "Не определен"
      }

      return item.name
    }

    function detect(status) {
      let items = optionValues.status.filter((item) => {
        return item["id"] === status
      })

      if (items.length === 0) {
        return null
      }

      return {
        name: items[0].name
      }
    }

    return {
      getVal,
    }
  }
})
</script>

<style scoped>

</style>
